import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { AccountService } from '../_services/account.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ReportDetailType, PolicyType, VehicleTypes, StatusCode } from 'src/app/_common/_enum/module.enum';
import { Months } from 'src/app/_common/months';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-mr-reporting-details',
  templateUrl: './mr-reporting-details.component.html',
  styleUrls: ['./mr-reporting-details.component.scss']
})
export class MrReportingDetailsComponent implements OnInit, OnDestroy {
  @Input() policyReportingDetails: any;
  @Output() messageEvent = new EventEmitter<boolean>();

  private netRateLoading: boolean = false;
  private exposureLoading: boolean = false;
  private exposureData: any;
  private report: any;
  private policyTypeEnum = PolicyType;
  private vehicleTypesEnum = VehicleTypes;
  private showVehicleType: boolean = false;
  private viewExposure: boolean = false;
  private reportDetailType = ReportDetailType;
  private paginationDate: any;
  private monthsConst = Months;
  private accountNumber: any;
  private hasAccess:boolean = false;
  
  constructor(private router: Router, private route: ActivatedRoute, private accountService: AccountService) { }

  ngOnInit() {
    console.log('policyReportingDetails. :: ', this.policyReportingDetails);
    this.accountNumber = this.policyReportingDetails.accountNumber;

    if(this.policyReportingDetails.detailType === ReportDetailType.MonthlyExposure) {
      this.fetchMonthlyExposure(this.policyReportingDetails.reportingPeriod.reportingPeriodStart, this.policyReportingDetails.reportingPeriod.reportingPeriodEnd);
    } else {
      this.fetchPolicyNetRates();
    }
  }

  fetchMonthlyExposure(_reportStartDate, _reportEndDate){
    this.exposureLoading = true;
    let pipe = new DatePipe('en-US');
    let _reportDetails = {
      accountNumber: this.accountNumber,
      startDate: _reportStartDate,
      endDate: _reportEndDate
    }
    let monthlyExposureSubscription = this.accountService.fetchMonthlyExposure(_reportDetails).subscribe((data:any)=>{
      this.exposureLoading = false;
      console.log(data);
      this.exposureData = data;
      this.exposureData.periodStartDate = new Date(pipe.transform(this.exposureData.periodStartDate, 'MM/dd/yyyy', 'UTC'));
      this.exposureData.periodEndDate = new Date(pipe.transform(this.exposureData.periodEndDate, 'MM/dd/yyyy', 'UTC'));
      this.exposureData.periodDueDate = new Date(pipe.transform(this.exposureData.periodDueDate, 'MM/dd/yyyy', 'UTC'));
      this.exposureData.completedDate = new Date(pipe.transform(this.exposureData.completedDate, 'MM/dd/yyyy', 'UTC'));
      
      this.exposureData.policyCoverages.forEach(_coverage => {
        if (this.policyReportingDetails.lobName === this.policyTypeEnum.AUTOMOBILE && !this.showVehicleType) {
          this.showVehicleType = _coverage.premiumBasis.toLowerCase() == this.vehicleTypesEnum.VEHICLE;
        }
      });

      this.updatePaginationDate(this.exposureData.periodStartDate);
    },
    error=>{
      this.exposureLoading = false;
      this.hasAccess = !(error.status == StatusCode.NoAccess);
    });
    this.accountService.runningServices.push(monthlyExposureSubscription);
  }

  fetchPolicyNetRates() {
    let pipe = new DatePipe('en-US');
    this.exposureLoading = true;
    let _policyEffectiveDate = new Date(pipe.transform(this.policyReportingDetails.policyEffectiveDate, 'MM/dd/yyyy', 'UTC'));
    let _reportStartDate =  new Date(pipe.transform(this.policyReportingDetails.reportingPeriod.reportingPeriodStart, 'MM/dd/yyyy', 'UTC'));

    let policyDetails = {
      "policyNumber": this.policyReportingDetails.policyNumber,
      "periodStartDate": _policyEffectiveDate > _reportStartDate ? this.policyReportingDetails.policyEffectiveDate : this.policyReportingDetails.reportingPeriod.reportingPeriodStart,
      "periodEndDate": this.policyReportingDetails.reportingPeriod.reportingPeriodEnd,
      "lobName": this.policyReportingDetails.lobShortName
    }
    let policyNetRateSubscription = this.accountService.fetchPolicyNetRates(policyDetails).subscribe((data:any)=>{
      this.exposureLoading = false;
      console.log(data);
      this.exposureData = data;
      if(!this.exposureData.periodDueDate){
        this.exposureData.periodDueDate = new Date(pipe.transform(this.policyReportingDetails.reportingPeriod.dueDate, 'MM/dd/yyyy', 'UTC'));
      }
    },
    error=>{
      this.exposureLoading = false;
      this.hasAccess = !(error.status == StatusCode.NoAccess);
    });
    this.accountService.runningServices.push(policyNetRateSubscription);
  }

  backToSchedule() {
    console.log('clicked back !!!!!!!!');
    this.messageEvent.emit(this.viewExposure);
  }

  updatePaginationDate(_date) {
    let reportDate = new Date(_date);

    this.paginationDate = this.monthsConst[reportDate.getMonth()] + " " + reportDate.getFullYear();
    
    console.log('reportDate :: ', reportDate);
    console.log('this.paginationDate :: ', this.paginationDate);
    
  }

  ngOnDestroy() {
    this.accountService.runningServices.forEach(subscription =>subscription.unsubscribe());
  }
}
